// import jquey
var $ = require("jquery");

$(document).ready(function () {
    /*------------------------------------
        form validation
    ------------------------------------- */
    var arValidationMessages = {
        first_name: "يجب ادخال هذا الحقل",
        last_name: "يجب ادخال هذا الحقل",
        phone: {
            required: "يجب ادخال هذا الحقل",
            // minlength: "يجب ألا يقل رقم الهاتف عن 8 رقما",
            // maxlength: "يجب ألا يزيد رقم الهاتف عن 10 رقما",
            // number: "يجب أن يحتوي الحقل على ارقام فقط"
        },
        country: "يجب ادخال هذا الحقل",
        city: "يجب ادخال هذا الحقل",
        business_type: "يجب ادخال هذا الحقل",
        branches_number: {
            required: "يجب ادخال هذا الحقل",
            number: "يجب أن يحتوي هذا الحقل على ارقام فقط"
        },
        // account_url: {
        //     required: "يجب ادخال هذا الحقل",
        //     url: "يجب ادخال عنوان صحيح"
        // },
        email: {
            required: "يجب ادخال هذا الحقل",
            email: "يجب ادخال بريد الكتروني صحيح"
        },
        user_name: "يجب ادخال هذا الحقل",
        password: {
            required: "يجب ادخال هذا الحقل",
            minlength: "كلمة المرور يجب ان تكون علي الاقل 6 احرف"
        },
        confirm_password: {
            required: "يجب ادخال هذا الحقل",
            equalTo: "يجب تاكيد كلمة المرور"
        },
    };

    var enValidationMessages = {
        first_name: "This field is required",
        last_name: "This field is required",
        phone: {
            required: "This field is required",
            // minlength: "This field must be at least 8 numbers",
            // maxlength: "This field must be at maximum 10 numbers",
            number: "This field must contain numbers only"
        },
        country: "This field is required",
        city: "This field is required",
        business_type: "This field is required",
        branches_number: {
            required: "This field is required",
            number: "This field must contain numbers only"
        },
        // account_url: {
        //     required: "This field is required",
        //     url: "Please enter a valid url"
        // },
        email: {
            required: "This field is required",
            email: "Please enter a valid email address"
        },
        user_name: "This field is required",
        password: {
            required: "This field is required",
            minlength: "Your password must be at least 6 characters"
        },
        confirm_password: {
            required: "This field is required",
            equalTo: "Please enter the same password as above"
        },
    };

    var validationMessages = $("body").hasClass("ar") ? arValidationMessages : enValidationMessages;
    var registerForm = $("#registration-form");

    var validatedForm = registerForm.validate({
        errorClass: "error-feedback",
        rules: {
            first_name: "required",
            last_name: "required",
            phone: {
                required: true,
                // minlength: 8,
                // maxlength: 10,
                number: true
            },
            country: "required",
            city: "required",
            business_type: "required",
            branches_number: {
                required: true,
                number: true
            },
            // account_url: {
            //     required: true,
            //     url: true
            // },
            email: {
                required: true,
                email: true
            },
            user_name: "required",
            password: {
                required: true,
                minlength: 6
            },
            confirm_password: {
                required: true,
                equalTo: "#password"
            },
        },
        messages: validationMessages
    });

    // registration modal steps
    $("[data-step]").on("click", function () {
        if ($(this).hasClass("back-btn")) {
            $($(this).data("step")).show().siblings().hide();
        } else {
            if (validatedForm.form()) {
                $($(this).data("step")).show().siblings().hide();
            }
        }

    });

    // on hide modal reset the form
    $('#register-modal').on('hide.bs.modal', function (e) {
        // clear all inputs
        $(".validated-form").find(".form-control").val("");
        // show first step
        $(".validated-form").find("#step-1").show().siblings().hide();
        // clear error class and messages
        validatedForm.resetForm();
    });

    // submit register form
    registerForm.on("submit", function (e) {
        e.preventDefault();
        if ($(this).valid()) {
            console.log($(this).serializeArray());
            var data = $(this).serializeArray();
            var dataObj = {};
            data.forEach(item => {
                dataObj[item.name] = item.value;
            });
            console.log(dataObj);
        }
    });
});

window.addEventListener("load", function () {
    // remove loading spinner
    document.getElementById("loading-container").remove();
    console.log("hhhhhhhh");
    // ============================================  header ====================================
    function stickyHeader() {
        var headerElement = document.getElementById("header");
        var scollCondition = window.scrollY >= headerElement.clientHeight;
        // add sticky classe if the condition is true
        headerElement.classList.toggle("sticky", scollCondition);
    }
    stickyHeader();
    window.addEventListener("scroll", stickyHeader);

    // toggle header nav
    document.getElementById("toggle-nav-icon").addEventListener("click", function () {
        document.getElementById("header-nav").classList.toggle("show");
        this.classList.toggle("open");
    });

    // header smooth scroll and add calss active onscroll
    $("[data-nav]").on("click", function (e) {
        e.preventDefault();
        $(this).parent().addClass("active").siblings().removeClass("active");
        $("html, body").animate({
            scrollTop: $($(this).data("nav")).offset().top - 70
        }, 500);
    });
    $(window).on("scroll", function () {
        $(".section").each(function () {
            if ($(window).scrollTop() >= $(this).offset().top - 100) {
                //find link that data-nav == the section id
                $('[data-nav="#' + $(this).attr("id") + '"' + ']').parent().addClass("active").siblings().removeClass("active");
            }
        });
    });


    // ============================================  home page ====================================
    // customers slider
    var directionMode = $("body").hasClass("ar") ? true : false;
    $('.customers-slider').slick({
        infinite: false,
        autoplay: true,
        arrows: false,
        dots: true,
        speed: 400,
        slidesToShow: 5,
        slidesToScroll: 5,
        responsive: [{
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            }
        ],
        rtl: directionMode,
    });
    // show more services
    $("#load-more-services").on("click", function (e) {
        e.preventDefault();
        $(".services-section .service").show();
        $(this).hide().removeClass("d-flex");
    });

    // show service modal
    var serviceModalContent = $("#service-modal-content");
    var serviceModalPrevBtn = $("#service-modal #prev-btn");
    var serviceModalNextBtn = $("#service-modal #next-btn");

    function checkServicesBtns() {
        serviceModalPrevBtn.show();
        serviceModalNextBtn.show();
        if ($("#services-section .service.active").is(":first-of-type")) {
            serviceModalPrevBtn.hide();
        }
        if ($("#services-section .service.active").is(":last-of-type")) {
            serviceModalNextBtn.hide();
        }
    }
    $("#services-section .card").on("click", function (e) {
        e.preventDefault();
        var activeCard = $(this).closest(".service");
        activeCard.addClass("active").siblings().removeClass("active");
        serviceModalContent.hide().fadeIn(300).html(activeCard.html());
        checkServicesBtns();
        $('#service-modal').modal('show');
    });


    serviceModalNextBtn.on("click", function () {
        $("#services-section .service.active").removeClass("active").next().addClass("active");
        checkServicesBtns();
        serviceModalContent.hide().fadeIn(300).html($("#services-section .service.active").html());
    });

    serviceModalPrevBtn.on("click", function () {
        $("#services-section .service.active").removeClass("active").prev().addClass("active");
        checkServicesBtns();
        serviceModalContent.hide().fadeIn(300).html($("#services-section .service.active").html());
    });

});